module.exports = __webpack_public_path__ + "img/hotproduct-3.69b06450.jpg";